import React from "react"

import { Color } from "../../../constants/V2/color"
import {
  WEB_TO_LEAD_FORM_IDS,
  IMAGE_URL,
} from "../../../constants/V2/salesForm"
import CheckboxFormikField from "../../elements/V2/Inputs/Checkbox"
import Typography from "../../elements/V2/Typography"

import InputError from "@components/elements/V2/Inputs/InputError"
import InputInstructions from "@components/elements/V2/Inputs/InputInstructions"

interface Props {
  touched: {
    [x: string]: string | boolean | undefined
  }
  errors: {
    [x: string]: string | boolean | undefined
    checkboxErrorMessage?: string
    radioErrorMessage?: string
  }
  preselectedProduct?: string
}

const FormProductOptions = ({ touched, errors, preselectedProduct }: Props) => {
  const hasError =
    errors.checkboxErrorMessage &&
    (touched[WEB_TO_LEAD_FORM_IDS.yocoKhumo] ||
      touched[WEB_TO_LEAD_FORM_IDS.yocoNeoTouch] ||
      touched[WEB_TO_LEAD_FORM_IDS.yocoGateway] ||
      touched[WEB_TO_LEAD_FORM_IDS.yocoLink] ||
      touched[WEB_TO_LEAD_FORM_IDS.yocoInvoices] ||
      touched[WEB_TO_LEAD_FORM_IDS.yocoPointOfSale] ||
      touched[WEB_TO_LEAD_FORM_IDS.xeroIntegration])
  if (preselectedProduct) {
    return (
      <div className="hidden">
        <input
          type="checkbox"
          id={preselectedProduct}
          name={preselectedProduct}
          value="true"
          readOnly={true}
          checked={!!preselectedProduct}
        />
      </div>
    )
  } else {
    return (
      <>
        <Typography
          color={Color.Black}
          text="3. What Yoco products are you interested in?"
          font="grotesk"
          size="body-lg"
          weight="medium"
          className="mb-8"
        />
        {hasError ? (
          <InputError
            error="Select at least 1 option below"
            className="mb-16 pt-[1px]"
          />
        ) : (
          <InputInstructions
            error="Select at least 1 option below"
            className="mb-16 pt-[1px]"
          />
        )}

        <div className="mb-32 flex flex-col flex-wrap gap-12 sm:flex-row">
          <div className="flex w-full flex-col gap-16 sm:w-[269px]">
            <CheckboxFormikField
              label="Neo Touch"
              id={WEB_TO_LEAD_FORM_IDS.yocoNeoTouch}
              image={IMAGE_URL.yocoNeoTouch}
              data-testid="yoco-neo-checkbox"
            />
            <CheckboxFormikField
              label="Khumo"
              id={WEB_TO_LEAD_FORM_IDS.yocoKhumo}
              image={IMAGE_URL.yocoKhumo}
              data-testid="yoco-khumo-checkbox"
            />
            <CheckboxFormikField
              label="Khumo Print"
              id={WEB_TO_LEAD_FORM_IDS.yocoKhumoPrint}
              image={IMAGE_URL.yocoKhumoPrint}
              data-testid="yoco-khumo-print-checkbox"
            />
            <CheckboxFormikField
              label="Gateway"
              id={WEB_TO_LEAD_FORM_IDS.yocoGateway}
              image={IMAGE_URL.yocoGateway}
              data-testid="yoco-gateway-checkbox"
            />
          </div>
          <div className="flex w-full flex-col gap-16 sm:w-[269px]">
            <CheckboxFormikField
              label="Point of sale"
              id={WEB_TO_LEAD_FORM_IDS.yocoPointOfSale}
              image={IMAGE_URL.yocoPointOfSale}
              data-testid="yoco-pointofsales-checkbox"
            />
            <CheckboxFormikField
              label="Link"
              id={WEB_TO_LEAD_FORM_IDS.yocoLink}
              image={IMAGE_URL.yocoLink}
              data-testid="yoco-link-checkbox"
            />
            <CheckboxFormikField
              label="Invoices"
              id={WEB_TO_LEAD_FORM_IDS.yocoInvoices}
              image={IMAGE_URL.yocoInvoices}
              data-testid="yoco-invoices-checkbox"
            />
            <div className="w-full sm:w-[269px]">
              <CheckboxFormikField
                label="Xero integration"
                id={WEB_TO_LEAD_FORM_IDS.xeroIntegration}
                image={IMAGE_URL.xeroIntegration}
                data-testid="xero-integration-checkbox"
              />
            </div>
          </div>
        </div>
        <Typography
          color={Color.Charcoal}
          text="Not sure about the products?"
          font="grotesk"
          size="body-lg"
          weight="medium"
          className="mb-8 sm:mb-16"
        />

        <CheckboxFormikField
          label="I'm not sure"
          id={WEB_TO_LEAD_FORM_IDS.unsure}
          data-testid="unsure-checkbox"
        />
      </>
    )
  }
}

export default FormProductOptions
